<script>
export default {
    name: "DeclineApproval",

    props: {

        journalDetails: Object,
        showModal: Boolean
    },

    methods: {

        confirmDecline() {
            this.$root.loading = true;
            this.$accountsHttp.post(`InventoryJournal/ApproveInventoryJournal`, this.journalDetails).then(() => {
                this.$root.loading = false;
                this.$emit('closeModal');
            }).catch(() => { this.$root.loading = false; this.$emit('closeModal'); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 w-3/4">
      <template v-slot:modal-body>
        <div class="w-full -m-4">
          <h5 class="text-center font-semibold">Confirm decline of the journals.</h5>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-8" @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs" @click.prevent="confirmDecline">
            <i class="fa fa-times"></i> Decline
            </button>
      </template>
    </tail-modal>
</template>
